import React from 'react';

import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
} from '$/GraphQL/schema/schema';
import { InteractionModalAccordionsHook, InteractionModalComponentProps } from '../types';
import { InteractionInfo, InvisibleNotificationProps, NoBodyCard } from '../InteractionInfo';

import { AnalyticsCardProps } from '../cards/types';
import { InvisibleNotification } from './InvisibleNotification';
import { PrivateMessageCard } from './PrivateMessageCard';
import { usePrivateSettings } from './usePrivateSettings';

const PrivateMessageModal = React.lazy(() => import('./PrivateMessageModal'));
const AnalyticsClickCard = React.lazy(() => import('../cards/AnalyticsClickCard'));

export class PrivateMessageInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public hasEndsAt(): boolean {
    return false;
  }

  public hasPinToTopToggle(): boolean {
    return false;
  }

  public showWebinarPlayer(): boolean {
    return false;
  }

  public isVisibleToAttendee(): boolean {
    return true;
  }

  public isInteractiveCard(): boolean {
    return false;
  }

  public hasCard(isPreview?: boolean): boolean {
    return Boolean(isPreview);
  }

  public hasEngagement(): boolean {
    return false;
  }

  public notificationComponentForAttendee(): React.FC<InvisibleNotificationProps> | null {
    return InvisibleNotification;
  }

  public cardComponent(): React.FC<{ onClickHeader?: () => void }> {
    return PrivateMessageCard;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return PrivateMessageModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return usePrivateSettings;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }

  public cardBodyComponent(): React.FC<{}> {
    return NoBodyCard;
  }
}
